function findRemoteFunc(list, funcList, tokenFuncList, blankList) {
	for(let i = 0; i < list.length; i++) {
		if(list[i].type == 'grid') {
			list[i].options.filter(x => x.attrName == 'grid')[0].group.forEach(item => {
				findRemoteFunc(item.list, funcList, tokenFuncList, blankList)
			})
		} else {
			if(list[i].type == 'blank') {
				if(list[i].model) {
					blankList.push({
						name: list[i].model,
						label: list[i].name
					})
				}
			} else if(list[i].type == 'imgupload') {
				if(list[i].options.tokenFunc) {
					tokenFuncList.push({
						func: list[i].options.tokenFunc,
						label: list[i].name,
						model: list[i].model
					})
				}
			} else {
				if(list[i].options !== "" && list[i].options !== null && list[i].options !== undefined) {
					if(list[i].options.remote && list[i].options.remoteFunc){
						funcList.push({
							func: list[i].options.remoteFunc,
							label: list[i].name,
							model: list[i].model
						})
					}
				}
			}
		}
	}
}

export default function(data,keepaliveName) {

	const funcList = []

	const tokenFuncList = []

	const blankList = []

	findRemoteFunc(JSON.parse(data).list, funcList, tokenFuncList, blankList)

	let funcTemplate = ''

	let blankTemplate = ''

	for(let i = 0; i < funcList.length; i++) {
		funcTemplate += `
            ${funcList[i].func} (resolve) {
              // ${funcList[i].label} ${funcList[i].model}
              // 获取到远端数据后执行回调函数
              // resolve(data)
            },
    `
	}

	for(let i = 0; i < tokenFuncList.length; i++) {
		funcTemplate += `
            ${tokenFuncList[i].func} (resolve) {
              // ${tokenFuncList[i].label} ${tokenFuncList[i].model}
              // 获取到token数据后执行回调函数
              // resolve(token)
            },
    `
	}

	for(let i = 0; i < blankList.length; i++) {
		blankTemplate += `
        <template slot="${blankList[i].name}" slot-scope="scope">
          <!-- ${blankList[i].label} -->
          <!-- 通过 v-model="scope.model.${blankList[i].name}" 绑定数据 -->
        </template>
    `
	}
	//   
	
	return `<template>
	<div style="height: 100%;">
    <fm-generate-form 
	  style="height: 100%;"
      :data="jsonData" 
      :remote="remoteFuncs" 
			:value="editData" 
			:disabled="disabled"
			ref="generateForm"
    >
		${blankTemplate}
		<template :slot="key" v-for="(val,key) in $slots">
			<slot :name="key"></slot>
		</template>
    </fm-generate-form>
	 </div>
</template>
<script>
	let vm = {}
	module.exports = {
		name:'${keepaliveName}',
		props:['disabled'],
	  data () {
			vm = this;
	    return {
	      jsonData: ${data},
				editData: {},
				func:function(){},
	      remoteFuncs: {
					func_test(resolve) {
						if (this.jsonData && eval("("+this.jsonData+")").list.filter(item => item.type == 'select').length>0) {
              vm.axios({
                url: eval("("+this.jsonData+")").list.filter(item => item.type == 'select')[0].options.filter(item => item.attrName == 'dynamicChange')[0].list[0].funcContent,
                method: eval("("+this.jsonData+")").list.filter(item => item.type == 'select')[0].options.filter(item => item.attrName == 'dynamicChange')[0].list[0].method,
                data: eval("("+this.jsonData+")").list.filter(item => item.type == 'select')[0].options.filter(item => item.attrName == 'dynamicChange')[0].list[0].data
              })
                .then(res => {
                  let optionData = res.data.rows.map(x => {
                    let obj = {};
                    obj.value = x[eval("("+this.jsonData+")").list.filter(item => item.type == 'select')[0].options.filter(item => item.attrName == 'dynamicChange')[0].list[0].Value];
                    obj.label = x[eval("("+this.jsonData+")").list.filter(item => item.type == 'select')[0].options.filter(item => item.attrName == 'dynamicChange')[0].list[0].Label];
                    return obj;
									});
									resolve(optionData);
                })
                .catch(err => {
                  vm.$message.error(err.msg);
                });
          }
					},
	        ${funcTemplate}
				},
	    }
		},
		beforeRouterEnter(){
      next(vm => {
        if (vm.againload) {
          vm.againload();
        }
      })
    }
	}
	</script>`
}



// WEBPACK FOOTER //
// ./src/components/vueformmaking/createVue.js